import React, { useState } from "react";
import { useStyles } from "./OverviewStyle";
import UseOverview from "./UseOverview";
import Switch from "@material-ui/core/Switch";
import InfoIcon from "../../../assets/serviceimgs/infoIcon.png";
import KafkaIcon from "../../../assets/serviceimgs/rightIcon.png";

export default function OverView() {
  const classes = useStyles();
  const [{ data1, data2 }] = UseOverview();

  const [tab, setTab] = useState(false);
  const [newData, setNewData] = useState(data2);

  const [state, setState] = React.useState({
    checkedA: true,
    checkedB: false,
  });
  const updateTableData = (title, key, value) => {
    const newTableData = newData.filter((item) => {
      if (item.title === title) {
        item.switch[key] = value;
      }
      return item;
    });
    setNewData(newTableData);
  };
  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  return (
    <div className={classes.container}>
      <h3 className={classes.connectionTitile}>Connection information</h3>

      {/* /table 1/ */}
      {data1.map((item, index) => {
        return (
          <div
            style={{ backgroundColor: item.bgColor }}
            className={classes.rowContainer}
          >
            <div className={classes.row1}>
              <p className={classes.boldText}>{item.title}</p>
            </div>
            <div className={classes.row2}>
              <p style={{ color: item.color }} className={classes.normalText}>
                {item.heading}
              </p>
            </div>
            <div className={classes.row3}>
              {item.text ? (
                <p style={{ color: item.color }} className={classes.downText}>
                  {item.text}
                </p>
              ) : (
                ""
              )}

              <img src={item.icon} width={20} alt="img" />
            </div>
          </div>
        );
      })}
      {/* /table 2/ */}
      <div className={classes.table2Container}>
        {newData.map((item, index) => {
          return (
            <div
            onClick={()=>alert(index)}
              style={{
                backgroundColor: item.bgColor,
                borderRadius: index === 0 ? "12px 12px 0px 0px" : "",
                height: index === 7 ? "auto" : "",
              }}
              className={classes.rowContainer2}
            >
              <div className={classes.table2Row1}>
                <div className={classes.leftIconContainer}>
                  <p className={classes.boldText}>{item.title}</p>
                  {item.leftIcon ? (
                    <img
                      className={classes.leftIcon}
                      src={item.leftIcon}
                      width={20}
                      alt="img"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className={classes.table2Row2}>
                <p className={classes.normalText}>{item.heading}</p>
                {item.centerButton ? (
                  <div className={classes.centerButton}>
                    {item.centerButton}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className={classes.table2Row3}>
                {item.button ? (
                  <div className={classes.button}>{item.button}</div>
                ) : item.switch ? (
                  <div className={classes.switcButton}>
                    <label className="switch">
                      <input type="checkbox" />
                      <span className="slider round"></span>
                    </label>
                  </div>
                ) : (
                  //     <div
                  //     onClick={(e) => updateTableData(item.title, 'value', !item.switch.value)}
                  //     className={`${item.switch.value? 'switchActive' : 'switch'} `}>
                  //     <div
                  //         className={`${item.switch.value? 'sliderActive' : 'slider'} `}></div>
                  // </div>
                  ""
                )}
              </div>
            </div>
          );
        })}
      </div>
      <div className={classes.configContainer}>
        <div className={classes.leftRow}>
          <p className={classes.leftRowText}>
            Advanced <br /> configuration
          </p>
        </div>
        <div className={classes.rightRow}>
          <div className={classes.infoContainer}>
            <div className={classes.infoIconContainer}>
              <img src={InfoIcon} width={36} alt="img" />
            </div>
            <div>
              <p className={classes.info}>INFO</p>
              <p className={classes.infoHeading}>
                Making advanced configuration changes may lead to your service
                restarting
              </p>
            </div>
          </div>
          <div className={classes.kafkaContainer}>
            <p className={classes.kafkaTitle}>
              Kafka authetication_methods.sasl
            </p>
            <img
              className={classes.kafkaIcon}
              src={KafkaIcon}
              width={16}
              alt="img"
            />
            <div className={classes.kafkaSwitcButton}>
              <label className="switch">
                <input type="checkbox" />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
          {/* // */}
          <div className={classes.kafkaContainer}>
            <p className={classes.kafkaTitle}>
              Kafka authetication_methods.sasl
            </p>
            <img
              className={classes.kafkaIcon}
              src={KafkaIcon}
              width={16}
              alt="img"
            />
            <div className={classes.kafkaSwitcButton}>
              <label className="switch">
                <input type="checkbox" />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
          <div>
            <p className={classes.addText}>
              <span className={classes.addIcon}>+</span> Add configuration
              option
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
